import React, { Fragment } from "react";

import Divider from "@mui/material/Divider";

import Switch from "../../../../components/Redux/Switch";
import { ReduxTextField } from "../../../../components/Redux/TextField";
import SettingSection from "../../../../components/SettingSection";
import TabSection from "../../../../components/styled/TabSection";
import {
  getRouteFormProperty,
  setRouteFormError,
  setRouteFormProperty,
} from "../../../../slices/routes";
import { validateDuration } from "../../../../validators/duration";
import { SectionProps } from "./common";

export const Timeouts = ({ readonly, tabValue }: SectionProps) => {
  const sections = [
    {
      key: "allow-websockets",
      node: (
        <SettingSection
          label="Allow Websockets"
          docsKey="websocket-connections"
        >
          <Switch
            path="allowWebsockets"
            label=""
            disabled={readonly}
            setter={setRouteFormProperty}
            getter={getRouteFormProperty}
            errorHandler={setRouteFormError}
          />
        </SettingSection>
      ),
    },
    {
      key: "allow-spdy",
      node: (
        <SettingSection label="Allow SPDY" docsKey="spdy">
          <Switch
            path="allowSpdy"
            label=""
            disabled={readonly}
            setter={setRouteFormProperty}
            getter={getRouteFormProperty}
            errorHandler={setRouteFormError}
          />
        </SettingSection>
      ),
    },
    {
      key: "timeout",
      node: (
        <SettingSection label="Timeout" docsKey="route-timeout">
          <ReduxTextField
            disabled={readonly}
            fullWidth
            path="timeout"
            setter={setRouteFormProperty}
            getter={getRouteFormProperty}
            errorHandler={setRouteFormError}
            validator={validateDuration}
          />
        </SettingSection>
      ),
    },
    {
      key: "idle-timeout",
      node: (
        <SettingSection label="Idle Timeout" docsKey="route-idle-timeout">
          <ReduxTextField
            fullWidth
            path="idleTimeout"
            disabled={readonly}
            setter={setRouteFormProperty}
            getter={getRouteFormProperty}
            errorHandler={setRouteFormError}
            validator={validateDuration}
          />
        </SettingSection>
      ),
    },
  ];

  return (
    <TabSection index={"timeouts"} value={tabValue} title="Timeouts">
      {sections.map(({ key, node }, index) => (
        <Fragment key={key}>
          {node}
          {index < sections.length - 1 ? <Divider /> : null}
        </Fragment>
      ))}
    </TabSection>
  );
};
